
import { defineComponent } from "vue";
import api, { ReceiverEventList, ReceiverEvent, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: ReceiverEventList;
  requestFilter: ReceiverEvent;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
  filterOptions: Record<string, unknown>;
}

export default defineComponent({
  name: "ReceiverEvent",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const filter_options = {
      'Initiator': [
        'user',
        'system',
        'producer',
        'consumer',
      ],
      'Class': [
        'audit',
        'error',
        'alert',
        'health',
      ],
      'Condition': [
        'instant',
        'open',
        'closed',
        'closing',
      ],
    };
    const event_list = { } as ReceiverEventList;
    const event_struct = { } as ReceiverEvent;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    return {
      msg: "Receiver Events",
      backendResponse: event_list,
      requestFilter: event_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      filterOptions: filter_options,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDate,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as ReceiverEvent;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse = { } as ReceiverEventList;
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getEventList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
